/* ============================================================
   KICA — globally-loaded UI logic
   Loaded from layout/theme.liquid for every storefront page.

   1. Back-to-top button: show after a meaningful scroll, click
      smoothly scrolls to top. Handles both the global button
      and the in-sticky one on product pages (shared data attribute).
   2. Sticky-header scroll-up lock: toggle a body attribute based
      on scroll direction. CSS in kica-overlay.css does the rest.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. Back-to-top button ---------- */
  var SCROLL_THRESHOLD = 400;
  var globalBtn = document.querySelector('.kica-back-to-top--global');

  function toggleGlobalBtn() {
    if (!globalBtn) return;
    globalBtn.hidden = window.scrollY <= SCROLL_THRESHOLD;
  }

  if (globalBtn) {
    window.addEventListener('scroll', toggleGlobalBtn, { passive: true });
    toggleGlobalBtn();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-kica-back-to-top]');
    if (!trigger) return;
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- 2. Sticky-header scroll-up lock ----------
     Sets body[data-kica-scroll-up] on any upward scroll and
     holds it for 600ms to absorb micro-jitter. Clears on
     downward scroll past a 5px buffer, or whenever we're near
     the top of the page (so the announcement bar can claim
     its natural slot above the header). CSS in kica-overlay.css
     reads the attribute and pins the header to the top. */
  var HOLD_MS = 600;
  var DOWN_BUFFER_PX = 5;
  var TOP_THRESHOLD_PX = 100;
  var lastY = window.scrollY;
  var holdUntil = 0;

  function setFlag(on) {
    var has = document.body.hasAttribute('data-kica-scroll-up');
    if (on && !has) document.body.setAttribute('data-kica-scroll-up', '');
    else if (!on && has) document.body.removeAttribute('data-kica-scroll-up');
  }

  function tick() {
    var y = window.scrollY;
    var now = performance.now();

    if (y <= TOP_THRESHOLD_PX) {
      // Near the top of the page — let the announcement-bar/header
      // sit in natural flow. Skip the lock regardless of direction.
      setFlag(false);
    } else if (y < lastY - 0.5) {
      holdUntil = now + HOLD_MS;
      setFlag(true);
    } else if (y > lastY + DOWN_BUFFER_PX && now > holdUntil) {
      setFlag(false);
    }

    lastY = y;
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();
